<template>
  <div class="containerAba">
    <div class="container limitW">
      <FilterDisp @unity="unidade" :valorTotal="dados.all" />
      <div>
        <InputFilter @valorDigitado="emitDigitado" />
        <!-- fazer um component e importar aqui! -->
      </div>
      <BgTable>
        <TitleTable>
          <Disponivel :filtro="unity" :dados="filtrarSearch" />
          <!-- <Disponivel v-if="showF" filtro="Filial" :dados="filtrarSearch" />
          <Disponivel v-if="showC" filtro="CD" :dados="filtrarSearch" />
          <Disponivel v-if="showJ" filtro="Jaguarão" :dados="filtrarSearch" /> -->
        </TitleTable>
      </BgTable>
    </div>
  </div>
  <!-- {{ filtrarSearch }} -->
</template>

<script>
import { isProxy, toRaw } from "vue";
import http from "../services/package/index";
import FilterDisp from "../components/Table/Filter/FilterDisp.vue";
import BgTable from "../components/Table/BgTable.vue";
import TitleTable from "../components/Table/TitleTable.vue";
import Disponivel from "../components/Table/Disponivel/Disponivel.vue";
import { verifyUser } from "../controllers/User/VerifyUserController";
import { useToast } from "vue-toastification";
import InputFilter from "../components/Table/Filter/InputFilter.vue";

export default {
  components: {
    FilterDisp,
    BgTable,
    TitleTable,
    Disponivel,
    InputFilter,
  },
  data: () => {
    return {
      showM: false,
      showF: true,
      showC: false,
      showJ: false,
      dados: [],
      unity: "",
      listData: [],
      valueSearch: "",
    };
  },
  methods: {
    async carregarDados(unity = "Galpão") {
      await http.ListByOrigin(unity).then((res) => {
        this.dados = res.data;
        if (isProxy(this.dados.data)) {
          this.listData = toRaw(this.dados.data);
        }
      });

      this.unity = unity;
    },
    unidade: async function (payload) {
      this.carregarDados(payload);
      this.unity = payload;
    },
    mostrarM: function () {
      this.showM = true;
      this.showF = false;
      this.showC = false;
      this.showJ = false;
    },
    mostrarF: function () {
      this.showM = false;
      this.showF = true;
      this.showC = false;
      this.showJ = false;
    },
    mostrarC: function () {
      this.showM = false;
      this.showF = false;
      this.showC = true;
      this.showJ = false;
    },
    mostrarJ: function () {
      this.showM = false;
      this.showF = false;
      this.showC = false;
      this.showJ = true;
    },

    emitDigitado(e) {
      this.valueSearch = e;
    },
  },
  async mounted() {
    this.carregarDados();
  },

  async created() {
    let token = sessionStorage.getItem("token");

    if (!token) {
      this.$router.push({ name: "Login" });
    }

    if (Object.entries(this.$store.state.userLogged).length == 0) {
      const user = await verifyUser();

      if (user instanceof Error) {
        const toast = useToast();
        sessionStorage.removeItem("token");
        toast.info("Sessão expirada", { timeout: 2250 });
        return this.$router.push({ name: "Login" });
      }

      this.$store.dispatch("userLogged", user);
    }

    if (
      this.$store.state.embalagens.length == 0 ||
      this.$store.state.modelos.length == 0 ||
      this.$store.state.clientes.length == 0
    ) {
      await this.$store.dispatch("instanciarState");
    }
  },

  computed: {
    filtrarSearch() {
      this.valueSearch = this.valueSearch.toLowerCase();

      let filtro = this.listData.filter((item) => {
        if (isProxy(item)) {
          item = toRaw(item);
          return item.description_model.toLowerCase().match(this.valueSearch);
        }
      });
      return filtro;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0 1rem;
}
</style>
